/**
 * Session lifecycle shortcuts.
 */
import { Sessions } from "../../features/analytics/sessions";

export class SessionTracker {
  constructor(public readonly client: Sessions) {}

  /** Start a new session. */
  start(opts?: Parameters<Sessions["start"]>[0]) {
    return this.client.start(opts);
  }

  /** Update an active session with new properties. */
  update(sessionId: string, properties: Record<string, unknown>) {
    return this.client.update(sessionId, properties);
  }

  /** End a session. */
  end(sessionId: string) {
    return this.client.end(sessionId);
  }

  /** Heartbeat to keep a session alive. */
  heartbeat(sessionId: string) {
    return this.client.heartbeat(sessionId);
  }

  /** Auto-manage browser session lifecycle (start, heartbeat, end on pagehide). */
  autoTrack(config?: Parameters<Sessions["autoTrack"]>[0], options?: { heartbeatMs?: number }) {
    return this.client.autoTrack(config, options);
  }
}
